import { call, put, select, takeLeading } from 'typed-redux-saga';

import { selectIsTeleMessenger } from '../../../../shared/features/config/selectors';
import { NOTIFICATIONS_MAP, notify } from '../../../../shared/features/notifications/ps-notifications';
import { copy } from '../../../../shared/helpers/clipboard';
import { countMetrika } from '../../../../shared/helpers/metrika';
import { getConferenceId, getConferenceShareLink } from '../../selectors';
import { NotificationId } from '../../types';
import { setShareConferenceLinkSuccess, shareCallAction } from './slice';

function* shareConferenceLinkSaga({ payload }: ReturnType<typeof shareCallAction>) {
    const conferenceShareLink = yield* select(getConferenceShareLink);
    if (!conferenceShareLink) return;
    const isSuccess = yield* call(copy, conferenceShareLink, true);
    const conferenceId = yield* select(getConferenceId);
    const isTeleMessenger = yield* select(selectIsTeleMessenger);

    if (isSuccess) {
        if (!payload?.calledOnJoin) {
            countMetrika('meeting_screen', 'share_meeting', 'share_by_link', conferenceId);

            if (isTeleMessenger) {
                yield* put(notify(NOTIFICATIONS_MAP[NotificationId.TELE_MESSENGER_LINK_COPIED]()));
            } else {
                yield* put(notify(NOTIFICATIONS_MAP[NotificationId.LINK_COPIED]()));
            }
        }
    } else {
        countMetrika('meeting_screen', 'share_meeting', 'share_by_link', 'share_error', conferenceId);
    }
    yield* put(setShareConferenceLinkSuccess(isSuccess));

    return isSuccess;
}

export function* shareConferenceLinkWatcher() {
    yield* takeLeading(shareCallAction, shareConferenceLinkSaga);
}
